import { render, staticRenderFns } from "./InspectionRecords.vue?vue&type=template&id=28e7ec31&"
import script from "./InspectionRecords.vue?vue&type=script&lang=js&"
export * from "./InspectionRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports